// app/ui/PostTitle.tsx
"use client";

import React from "react";

interface PostTitleProps {
  categoryName: string;
  categoryBg: string;
  title: string;
  createdAt: string;
}

export default function PostTitle({
  categoryName,
  categoryBg,
  title,
  createdAt,
}: PostTitleProps) {
  return (
    <div className="flex flex-col justify-center items-center border-b border-light-90 py-12 md:py-10">
      <div>
        <p
          className={`inline-block text-md-16 px-3 py-1 text-white rounded-full medium-text-18 ${categoryBg}`}
        >
          {categoryName}
        </p>
      </div>
      <h3 className="semibold-text-36 my-6 md:my-8 line-clamp-2 min-h-auto md:min-h-10 text-black-200 text-md-18">
        {title}
      </h3>
      <p className="regular-text-16 text-softGray-70">
        {new Date(createdAt).toLocaleDateString()}
      </p>
    </div>
  );
}
